export const CANAL_SOCKET = 3;
export const TIPO_RECEPTOR_USUARIO_SINERGIAL = 6;
